import { useQuery } from "@tanstack/react-query";
import { apiFetch } from "@/lib/api-fetch";

const API_BASE = `${import.meta.env.BASE_URL.replace(/\/$/, "")}/api`;

/**
 * Returns true for workspace admins AND owners (role level ≥ 80).
 * Use for sections that both admins and owners should access (e.g. compliance viewing, audit log).
 * For owner-only gating use useIsOwner() instead.
 */
export function useIsAdmin(): { isAdmin: boolean; isLoading: boolean } {
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "admin-access"],
    queryFn: async () => {
      const res = await apiFetch(`${API_BASE}/admin/admin-access`);
      if (!res.ok) return { ok: false };
      return res.json() as Promise<{ ok: boolean }>;
    },
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    isAdmin: data?.ok === true,
    isLoading,
  };
}
